function Testehtml() {
    
    return (
        <div style={{ marginLeft: '20px', marginTop: '20px', padding: '20px', color: 'black', backgroundColor: 'white' }}>
            <img src="https://www.brasilextremos.com.br/logo512.png" alt="Logo Brasil Extremos" width="200" />
                <h2 style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}>Resumo de Mensalidades - {new Date().getFullYear()}</h2>

                <h3 style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}>** LEIA ATENTAMENTE **</h3>

                <div>
                <p style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}>Prezado(a) Associado(a), seguimos com nosso compromisso de mantê-lo informado sobre suas mensalidades.</p>
                <hr />
                <p style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}><b>AVISO IMPORTANTE:</b></p>
                <p><b>É fundamental que você verifique atentamente o status de cada mensalidade.</b></p>
                <p><b>Manter suas mensalidades em dia é essencial para o bom funcionamento da associação.</b></p>
                <p><b>O não pagamento desse compromisso financeiro pode resultar em dificuldades na associação,</b>
                <b>comprometendo as obrigações financeiras, como custear a sede </b>
                <b>além de outras despesas essenciais para o bom funcionamento da associação.</b></p>
                <p><b>Bem como oferecer vantagens aos membros assíduos em eventos promovidos pela associação.</b></p>
                <p style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}><b>Portanto, é de extrema importância manter suas mensalidades em dia.</b></p>
                <p style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}><b>Agradecemos sua atenção e colaboração.</b></p>
                <p style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}><b>Em casos de dificuldades com o pagamento das mensalidades, entre em contato com a Tesouraria para orientação.</b></p>
                <p><b>Estamos à disposição para auxiliar em qualquer situação relacionada às mensalidades.</b></p>
                <hr style={{ marginBottom: '20px', marginTop: '20px' }} />
                <h3 style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}>SEGUE O RESUMO DAS MENSALIDADES DO ANO DE {new Date().getFullYear()}:</h3>
                <br />
                <p><b>Observação:</b> Este resumo é gerado automaticamente com base nos registros de pagamento disponíveis.</p>
                <p>Se houver alguma divergência ou dúvida, por favor, entre em contato com a Tesouraria.</p>
                <p>Tendo recibos ou comprovantes de pagamento, envie-os para o e-mail mgbrasilextremos@gmail.com,</p> 
                <p>ou envie pelo WhatsApp da Associação, para que possamos atualizar os registros.</p>
                <br />
                <span  style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}>
                <p>* O mês atual sempre é fechado no início do próximo,</p> 
                <p>  então se você já acertou a mensalidade antes do fechamento,</p> 
                <p>  ela será atualizada como "Pago" no próximo fechamento.</p>
                
                <br />
                <p>* Sua data de associação é:,</p>
                <p>  desconsidere pendências sinalizadas anteriores a essa data.</p>
                </span>
                </div>
                <hr style={{ marginBottom: '20px', marginTop: '20px' }} />
                <span>
                    <p>Segue abaixo o detalhamento:</p>
                    <ul>
                        <li>Janeiro: 'Pago'</li>
                        <li>Fevereiro: 'Pago'</li>
                        <li>Março: 'Pago'</li>
                        <li>Abril: 'Pago'</li>
                        <li>Maio: 'Pago'</li>
                        <li>Junho: 'Pago'</li>
                        <li>Julho: 'Pago'</li>
                        <li>Agosto: 'Pago'</li>
                        <li>Setembro: 'Pago'</li>
                        <li>Outubro: 'Pago'</li>
                        <li>Novembro: 'Pago'</li>
                        <li>Dezembro: 'Pago'</li>
                    </ul>
                </span>
                <br />
                <span  style={{ fontWeight: '600', marginBottom: '20px', marginTop: '20px' }}>
                <p>Atenciosamente,</p>
                <p>Tesouraria MG Brasil Extremos</p>
                </span>
                <br />
                <hr />
                <br />
                <div>
                    O conteúdo desse e-mail é confidencial e destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
        </div>
    );
}

export default Testehtml;
